import { render, staticRenderFns } from "./Schulte.vue?vue&type=template&id=78eaf115&lang=pug&"
import script from "./Schulte.vue?vue&type=script&lang=js&"
export * from "./Schulte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports